<template>
    <div class="container bng-slots bng-narrow-container">
        <game-list v-if="games.length" :games="games" />
    </div>
</template>

<script>
    import Vue from 'vue';

    import GameList from '../../../common/game-list/game-list.vue';

    export default {
        name: 'games-list',
        components: { GameList },
        computed: {
            gamesList() {
                return this.$route.params.gamesList;
            }
        },
        data() {
            return {
                games: []
            };
        },
        watch: {
            "$route.name": function() {
                this.loadGames();
            },
            gamesList() {
                this.loadGames();
            }
        },
        created() {
            this.loadGames();
        },
        methods: {
            loadGames() {
                const gl = this.gamesList.indexOf('gameslist.') === 0 ? this.gamesList : `gameslist.${this.gamesList}`; // fix games list name from url
                this.games = Vue.state.games.getByList(gl).games;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/games-list/games-list.vue